export function isPublicSectorOverviewPath(pathname: string): boolean {
  return /^\/sector\/[^/]+$/.test(pathname);
}
